export default __webpack_public_path__ + "static/image8-49615c2fff616c39fc1b79e59b7c5ee3.gif";